import { foldazApi } from 'api'
import {
  CREATE_CONTENT_COMMENT_REQUEST,
  CREATE_CONTENT_COMMENT_SUCCESS,
  CREATE_CONTENT_COMMENT_ERROR,
  SET_NEW_COMMENT_BODY
} from './types'

export const state = {
  newCommentBody: '',
  request: {
    isLoading: false,
    error: null
  }
}

export const mutations = {
  [CREATE_CONTENT_COMMENT_REQUEST] (state) {
    state.request.isLoading = true
  },
  [CREATE_CONTENT_COMMENT_SUCCESS] (state) {
    state.request.isLoading = false
    state.request.error = null
  },
  [CREATE_CONTENT_COMMENT_ERROR] (state, error) {
    state.request.isLoading = false
    state.request.error = error
  },
  [SET_NEW_COMMENT_BODY] (state, newCommentBody) {
    state.newCommentBody = newCommentBody
  }
}

export const actions = {
  createContentComment ({ commit, dispatch, state }, contentId) {
    commit(CREATE_CONTENT_COMMENT_REQUEST)
    return foldazApi.post(`/comments/content/${contentId}`, {
      comment: {
        body: state.newCommentBody
      }
    })
      .then(() => {
        commit(SET_NEW_COMMENT_BODY, '')
        commit(CREATE_CONTENT_COMMENT_SUCCESS)
      })
      .catch(error => commit(CREATE_CONTENT_COMMENT_ERROR, error))
  },
  setNewCommentBody ({ commit }, value) {
    commit(SET_NEW_COMMENT_BODY, value)
  }
}

export const getters = {}

export default {
  state,
  mutations,
  actions,
  getters
}



// WEBPACK FOOTER //
// ./src/store/modules/contents/contentCommentForm.js